
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.53 15.68"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M10.47 15.68h-8.4A2.07 2.07 0 0 1 0 13.62V2.07A2.07 2.07 0 0 1 2.07 0h8.4a2.07 2.07 0 0 1 2.06 2.07v11.55a2.06 2.06 0 0 1-2.06 2.06zM2.07 1.09a1 1 0 0 0-1 1v11.53a1 1 0 0 0 1 1h8.4a1 1 0 0 0 1-1V2.07a1 1 0 0 0-1-1z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M2.72 3.71h7.1V4.8h-7.1zM2.72 7.29h7.1v1.09h-7.1zM2.72 10.88h7.1v1.09h-7.1z"}})])])])
          )
        }
      }
    